import * as React from 'react';
import ReactHTMLParser from 'react-html-parser';
import styled, { css } from 'styled-components';
import { Box } from '@latitude/box';
import { Heading4 } from '@latitude/heading';
import { FramedContainer } from '@latitude/framed-container';
import { Text } from '@latitude/text';
import { BREAKPOINT, MARGIN, ALIGN, COLOR, PADDING, TEXT_VARIANT, FONT_SIZE } from '@latitude/core/utils/constants';
import imgConfettiLeft from './img/confetti-left.png';
import imgConfettiRight from './img/confetti-right.png';
var OuterContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ConfettiFramedContainer__OuterContainer",
  componentId: "sc-1j9rdci-0"
})(["padding:", " ", ";background:", ";"], PADDING.P48, PADDING.P16, function (_ref) {
  var plainBgColor = _ref.plainBgColor;
  return plainBgColor && plainBgColor.trim().length ? plainBgColor : COLOR.GREY6;
});
var Heading = /*#__PURE__*/styled(Heading4).withConfig({
  displayName: "ConfettiFramedContainer__Heading",
  componentId: "sc-1j9rdci-1"
})(["text-align:", ";color:", ";max-width:731px;margin-left:auto;margin-right:auto;", ""], ALIGN.CENTER, COLOR.BLACK, function (_ref2) {
  var subheading = _ref2.subheading;
  return subheading ? "margin-bottom: " + MARGIN.M8 + ";" : "margin-bottom: " + MARGIN.M24 + ";\n         @media (min-width: " + BREAKPOINT.SM + ") {\n           margin-bottom: " + MARGIN.M40 + ";\n         }";
});
var Subheading = /*#__PURE__*/styled(Text).withConfig({
  displayName: "ConfettiFramedContainer__Subheading",
  componentId: "sc-1j9rdci-2"
})(["text-align:", ";color:", ";margin:0 auto ", ";max-width:750px;@media (min-width:", "){margin-bottom:", ";}"], ALIGN.CENTER, COLOR.GREY75, MARGIN.M24, BREAKPOINT.SM, MARGIN.M32);
var ConfettiContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ConfettiFramedContainer__ConfettiContainer",
  componentId: "sc-1j9rdci-3"
})(["border:solid 1px transparent;margin:0 auto;width:100%;max-width:1250px;@media (min-width:", "){background-image:url(", "),url(", ");background-position:", ";background-repeat:no-repeat,no-repeat;background-size:229px 440px,193px 440px;}", ""], BREAKPOINT.XL, imgConfettiLeft, imgConfettiRight, function (_ref3) {
  var minHeight = _ref3.minHeight;
  return minHeight === '0' ? 'left top, right top' : 'left center, right center';
}, function (_ref4) {
  var plainBgColor = _ref4.plainBgColor;

  if (plainBgColor && plainBgColor.trim().length) {
    // make sure the background is cleared here
    // 'plainBgColor' is applied to 'OuterContainer'
    return css(["background:none;@media (min-width:", "){background:none;}"], BREAKPOINT.XL);
  }
});
var defaultInnerContainerMaxWidth = '700px';
var InnerContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ConfettiFramedContainer__InnerContainer",
  componentId: "sc-1j9rdci-4"
})(["margin:0 auto;width:100%;max-width:", ";"], function (_ref5) {
  var maxWidth = _ref5.maxWidth;
  return maxWidth && maxWidth.trim().length ? maxWidth : defaultInnerContainerMaxWidth;
});

var ConfettiFramedContainer = function ConfettiFramedContainer(_ref6) {
  var id = _ref6.id,
      heading = _ref6.heading,
      subheading = _ref6.subheading,
      children = _ref6.children,
      minHeight = _ref6.minHeight,
      hasPlainBgColor = _ref6.hasPlainBgColor,
      framedContainerTheme = _ref6.framedContainerTheme,
      innerContainerMaxWidth = _ref6.innerContainerMaxWidth;
  return /*#__PURE__*/React.createElement(OuterContainer, {
    id: id,
    plainBgColor: hasPlainBgColor
  }, heading && /*#__PURE__*/React.createElement(Heading, {
    subheading: !!subheading
  }, /*#__PURE__*/React.createElement("span", null, ReactHTMLParser(heading))), subheading && /*#__PURE__*/React.createElement(Subheading, {
    variant: TEXT_VARIANT.DIV,
    fontSize: FONT_SIZE.LARGE
  }, subheading), /*#__PURE__*/React.createElement(ConfettiContainer, {
    plainBgColor: hasPlainBgColor,
    minHeight: minHeight
  }, /*#__PURE__*/React.createElement(InnerContainer, {
    maxWidth: innerContainerMaxWidth
  }, /*#__PURE__*/React.createElement(FramedContainer, {
    theme: framedContainerTheme,
    minHeight: minHeight || '376px'
  }, children))));
};

export default ConfettiFramedContainer; // Custom style for ListNumbered content

export var ListNumberedWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ConfettiFramedContainer__ListNumberedWrapper",
  componentId: "sc-1j9rdci-5"
})(["padding:32px 24px 32px 40px;@media (min-width:", "){padding-right:40px;}ol li{text-align:left;min-height:0;}"], BREAKPOINT.LG);